'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

exports.default = init;

var _themeCart = require('@shopify/theme-cart');

var shopifyCart = _interopRequireWildcard(_themeCart);

var _functional = require('../utils/functional');

var _helpers = require('./_helpers');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(_ref) {
  var handleFormSubmit = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();

              _context.next = 3;
              return addItemToCart();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function handleFormSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var addItemToCart = function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var variantId, item;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              variantId = (0, _functional.getElement)('[name="id"]', { context: els.form }).value;

              if (variantId) {
                _context2.next = 3;
                break;
              }

              throw new Error(els.form + ' needs to have an input with a name of "id" in it.');

            case 3:
              _context2.prev = 3;

              state.loading = true;

              _context2.next = 7;
              return shopifyCart.addItem(parseInt(variantId, 10), {
                quantity: 1,
                properties: {}
              });

            case 7:
              item = _context2.sent;


              console.info('Added item to cart: ', item);

              state.popupOpen = true;
              _context2.next = 15;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2['catch'](3);

              state.errorPopupOpen = true;

            case 15:
              _context2.prev = 15;

              state.loading = false;
              return _context2.finish(15);

            case 18:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[3, 12, 15, 18]]);
    }));

    return function addItemToCart() {
      return _ref3.apply(this, arguments);
    };
  }();

  var el = _ref.el,
      context = _ref.context;

  var els = {
    el: el,
    form: context.getElement('.' + context.className + '_Form'),
    popup: context.getElement('.' + context.className + '_Popup'),
    popupClose: context.getElement('.' + context.className + '_PopupClose'),
    errorPopup: context.getElement('.' + context.className + '_ErrorPopup'),
    errorPopupClose: context.getElements('.' + context.className + '_ErrorPopupClose')
  };
  var state = new _helpers.ReactiveState({
    loading: false,
    popupOpen: false,
    errorPopupOpen: false
  });
  state.subscribe('loading', handleLoadingChange);
  state.subscribe('popupOpen', handlePopupOpenChange);
  state.subscribe('errorPopupOpen', handleErrorPopupOpenChange);

  function handleLoadingChange(val) {
    els.el.classList.toggle('prd-Card-loading', val);
  }

  function handlePopupOpenChange(val) {
    els.popup.setAttribute('aria-hidden', String(!val));
  }

  function handleErrorPopupOpenChange(val) {
    els.errorPopup.setAttribute('aria-hidden', String(!val));
  }

  var listeners = (0, _create2.default)(_helpers.Listeners);
  listeners.add(els.form, 'submit', handleFormSubmit);
  listeners.add(els.popupClose, 'click', handlePopupCloseClick);
  els.errorPopupClose.forEach(function (el) {
    return listeners.add(el, 'click', handleErrorPopupCloseClick);
  });

  function handlePopupCloseClick() {
    els.popup.setAttribute('aria-hidden', 'true');
  }

  function handleErrorPopupCloseClick() {
    els.errorPopup.setAttribute('aria-hidden', 'true');
  }
}